<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-15 px-7 type-project"
  >
    <div class="header">
      <div class="d-flex">
        <h1 class="title">
          {{ $t(template.projectTitle) }}
          <span v-if="itemMaxLength" class="max-length-guide">
            {{ $t('최대 입력 가능 갯수 : ') }} {{ $t(itemMaxLength) }}</span
          >
        </h1>
      </div>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideProject"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-8" v-if="obj">
          <v-row class="mt-2">
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" class="col-md-4">
                  <i-text-field
                    v-maxlength="'project_name'"
                    v-model="obj.projectName"
                    :label="itemLabel('projectName')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('projectName', true),
                      rules.maxlength('projectName'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="6" class="col-md-4">
                  <CommonDatePicker
                    :label="itemLabel('projectSdate')"
                    :rules="[rules.required('projectSdate', true)]"
                    v-model="obj.startDate"
                    :type="edateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col cols="6" class="col-md-4">
                  <CommonDatePicker
                    :label="itemLabel('projectEdate')"
                    :rules="[rules.required('projectEdate', true)]"
                    v-model="obj.endDate"
                    :min="obj.startDate"
                    :type="edateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="col-md-4">
                  <i-text-field
                    v-maxlength="'project_buyer'"
                    v-model="obj.projectBuyer"
                    :label="itemLabel('projectBuyer', true)"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('projectBuyer', true),
                      rules.maxlength('projectBuyer'),
                    ]"
                    :class="zeroRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="12" class="col-md-4">
                  <i-text-field
                    v-maxlength="'project_company'"
                    v-model="obj.projectCompany"
                    :label="itemLabel('projectCompany')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('projectCompany', true),
                      rules.maxlength('projectCompany'),
                    ]"
                    :class="zeroRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="12" class="col-md-4">
                  <i-text-field
                    v-maxlength="'project_contribution'"
                    v-model="obj.projectContribution"
                    :label="itemLabel('projectContribution')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('projectContribution', true),
                      rules.maxlength('projectContribution'),
                    ]"
                    :class="zeroRoundedClass"
                  ></i-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12">
              <i-text-field
                :label="itemLabel('projectDesc')"
                v-model="obj.projectDesc"
                outlined
                dense
                hide-details="auto"
                :rules="[
                  rules.required('projectDesc', true),
                  rules.maxlength('projectDesc'),
                ]"
              ></i-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="d-md-none d-block">
              <i-btn elevation="0" color="normal" outlined block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm" :readonly="isReadonly">
        <template v-for="(item, i) in projects">
          <v-divider :key="'projectdiv' + i" v-if="i != 0"></v-divider>
          <div class="mt-8" v-if="item" :key="'project' + i">
            <v-row class="mt-2">
              <v-col
                cols="12"
                :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
              >
                <v-row>
                  <v-col cols="12" class="col-md-4">
                    <i-text-field
                      v-maxlength="'project_name'"
                      v-model="item.projectName"
                      :label="itemLabel('projectName')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('projectName'),
                        rules.maxlength('projectName'),
                      ]"
                      @blur="save(i)"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="6" class="col-md-4">
                    <CommonDatePicker
                      :label="itemLabel('projectSdate')"
                      :rules="[rules.required('projectSdate')]"
                      @change="save(i)"
                      v-model="item.startDate"
                      :readonly="isReadonly"
                      :type="edateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                  <v-col cols="6" class="col-md-4">
                    <CommonDatePicker
                      :label="itemLabel('projectEdate')"
                      :rules="[rules.required('projectEdate')]"
                      @change="save(i)"
                      v-model="item.endDate"
                      :readonly="isReadonly"
                      :min="item.startDate"
                      :type="edateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="12" class="col-md-4">
                <i-text-field
                  v-maxlength="'project_buyer'"
                  v-model="item.projectBuyer"
                  :label="itemLabel('projectBuyer')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('projectBuyer'),
                    rules.maxlength('projectBuyer'),
                  ]"
                  @blur="save(i)"
                  :class="zeroRoundedClass"
                ></i-text-field>
              </v-col>
              <v-col cols="12" class="col-md-4">
                <i-text-field
                  v-maxlength="'project_company'"
                  v-model="item.projectCompany"
                  :label="itemLabel('projectCompany')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('projectCompany'),
                    rules.maxlength('projectCompany'),
                  ]"
                  @blur="save(i)"
                  :class="zeroRoundedClass"
                ></i-text-field>
              </v-col>
              <v-col cols="12" class="col-md-4">
                <i-text-field
                  v-maxlength="'project_contribution'"
                  v-model="item.projectContribution"
                  :label="itemLabel('projectContribution')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('projectContribution'),
                    rules.maxlength('projectContribution'),
                  ]"
                  @blur="save(i)"
                  :class="zeroRoundedClass"
                ></i-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="12">
                <i-text-field
                  :label="itemLabel('projectDesc')"
                  v-model="item.projectDesc"
                  outlined
                  dense
                  hide-details="auto"
                  @blur="save(i)"
                  :rules="[
                    rules.required('projectDesc'),
                    rules.maxlength('projectDesc'),
                  ]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-2" v-if="!isReadonly">
              <v-col cols="12" class="d-md-none d-block">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
          </div>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { mdiCalendarBlank } from '@mdi/js';
import { snack } from '@/plugins/dialog/api';

import CommonDatePicker from '@/components/common/CommonDatePicker.vue';

export default {
  components: { CommonDatePicker },
  mixins: [LoadingMixin],
  props: {
    itemDirectInput: {
      type: Function,
      default: () => {},
    },
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.project?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.project?.oMaxLength ||
        this.opts.project?.oMaxLength > this.projects.length
      );
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    project: '',
    itemSeq: 1,
    obj: null,
    projects: [],
    fileUploadYn: '',
    sdateFormat: '',
    edateFormat: '',
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];
      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }
      return label;
    },
    itemArray: function(key) {
      var array = [];
      if (this.opts && this.opts.hasOwnProperty(key)) {
        array = this.opts[key].oItems
          ? this.opts[key].oItems.split(this.itemDelimeter)
          : [];
      }
      return array;
    },
    setting: function() {
      if (this.template.typeProject) {
        this.project = this.template.typeProject;
      }

      if (this.opts) {
        let $this = this;
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'projectSdate') {
            $this.sdateFormat = prop.oFormat;
          } else if (prop.id.cvColumn === 'projectEdate') {
            $this.edateFormat = prop.oFormat;
          }
        }
      }
      this.dataSetting();
      this.obj = this.defaultObj();
    },
    dataSetting: function() {
      if (this.info && this.info.projects && this.info.projects.length > 0) {
        this.itemSeq = this.info.projects[0].id.seq;
        this.projects = [];

        let $this = this;
        this.info.projects.forEach(function(v) {
          var startDate = '';
          var endDate = '';

          if (v.projectSdate) {
            if ($this.sdateFormat === 'YYYY.MM') {
              startDate =
                v.projectSdate.substring(0, 4) +
                '-' +
                v.projectSdate.substring(4, 6);
            } else if ($this.sdateFormat === 'YYYY.MM.DD') {
              startDate =
                v.projectSdate.substring(0, 4) +
                '-' +
                v.projectSdate.substring(4, 6) +
                '-' +
                v.projectSdate.substring(6, 8);
            }
          }

          if (v.projectEdate) {
            if ($this.edateFormat === 'YYYY.MM') {
              endDate =
                v.projectEdate.substring(0, 4) +
                '-' +
                v.projectEdate.substring(4, 6);
            } else if ($this.edateFormat === 'YYYY.MM.DD') {
              endDate =
                v.projectEdate.substring(0, 4) +
                '-' +
                v.projectEdate.substring(4, 6) +
                '-' +
                v.projectEdate.substring(6, 8);
            }
          }

          let obj = {
            seq: v.id.seq,
            projectName: v.projectName,
            projectBuyer: v.projectBuyer,
            projectCompany: v.projectCompany,
            projectSdate: v.projectSdate,
            projectEdate: v.projectEdate,
            projectContribution: v.projectContribution,
            projectDesc: v.projectDesc,
            projectInYn: v.projectInYn,
            start: '',
            end: '',
            startDate: startDate,
            endDate: endDate,
          };

          $this.projects.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        projectName: '',
        projectBuyer: '',
        projectCompany: '',
        projectContribution: '',
        projectDesc: '',
        projectSdate: '',
        projectEdate: '',
        projectInYn: 'N',
        start: '',
        end: '',
        startDate: '',
        formattedStartDate: '',
        endDate: '',
        formattedEndDate: '',
      };
      return obj;
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          `${this.template.projectTitle} 은(는) 최대 ${this.opts.project.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },
    valid: function() {
      if (
        this.opts &&
        this.opts.project &&
        this.opts.project.oRequireYn &&
        this.opts.project.oRequireYn == 'Y' &&
        this.projects.length < 1
      ) {
        this.submitErrorMessage = '최소 1개의 정보는 존재하여야 합니다.';
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      var item = i === -1 ? this.obj : this.projects[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;
      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const p = {
        id: id,
        projectName: item.projectName,
        projectSdate: item.startDate.replace(pattern, ''),
        projectEdate: item.endDate.replace(pattern, ''),
        projectBuyer: item.projectBuyer,
        projectCompany: item.projectCompany,
        projectDesc: item.projectDesc,
        projectContribution: item.projectContribution,
        projectInYn: item.projectInYn,
      };
      this.$emit('save', p, 'project', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('PROJECT SAVE FAIL');
      } else snack.info(`${this.template.projectTitle}가 저장 되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.projects.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.projects[i].seq,
      };

      this.$emit('delete', p, 'project', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('PROJECT DELETE FAIL');
      } else {
        snack.danger(`${this.template.projectTitle}가 삭제 되었습니다.`);
        this.projects.splice(i, 1);
      }
      this.hideLoading();
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-career .sub-title-standard {
  position: relative;
}
.type-career .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-career .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
